import gobiernoCorporativo2022 from '../pdfs/Informe-de-Gobierno-Corporativo-2022.pdf';
import gobiernoCorporativo2023 from '../pdfs/Informe-de-Gobierno-Corporativo-2023.pdf';
import gobiernoCorporativo2024 from '../pdfs/Informe-de-Gobierno-Corporativo-2024.pdf';
import gobiernoCorporativo2025 from '../pdfs/Informe-de-Gobierno-Corporativo-2025.pdf';
import sostenibilidad2022 from '../pdfs/Informe-de-Gestion-y-Memoria-de-Sostenibilidad-2022.pdf';
import sostenibilidad2023 from '../pdfs/Informe-de-Gestion-y-Memoria-de-Sostenibilidad-2023.pdf';
import sostenibilidad2024 from '../pdfs/Informe-de-Gestion-y-Memoria-de-Sostenibilidad-2024.pdf';
import sostenibilidad2025 from '../pdfs/Informe-de-Gestion-y-Memoria-de-Sostenibilidad-2025.pdf';

export interface Informe {
  title: string;
  /** URL local resuelta por el bundler (nunca el WordPress antiguo). */
  pdf: string;
}

export interface InformesPorAnio {
  year: string;
  informes: Informe[];
}

export const INFORMES_POR_ANIO: InformesPorAnio[] = [
  {
    year: '2025',
    informes: [
      { title: 'Informe de Gobierno Corporativo 2025', pdf: gobiernoCorporativo2025 },
      { title: 'Informe de Gestión y Memoria de Sostenibilidad 2025', pdf: sostenibilidad2025 },
    ],
  },
  {
    year: '2024',
    informes: [
      { title: 'Informe de Gobierno Corporativo 2024', pdf: gobiernoCorporativo2024 },
      { title: 'Informe de Gestión y Memoria de Sostenibilidad 2024', pdf: sostenibilidad2024 },
    ],
  },
  {
    year: '2023',
    informes: [
      { title: 'Informe de Gobierno Corporativo 2023', pdf: gobiernoCorporativo2023 },
      { title: 'Informe de Gestión y Memoria de Sostenibilidad 2023', pdf: sostenibilidad2023 },
    ],
  },
  {
    year: '2022',
    informes: [
      { title: 'Informe de Gobierno Corporativo 2022', pdf: gobiernoCorporativo2022 },
      { title: 'Informe de Gestión y Memoria de Sostenibilidad 2022', pdf: sostenibilidad2022 },
    ],
  },
];

/** Ejercicio que se muestra en «Ultimas publicaciones»; los anteriores quedan en el histórico. */
export const DESTACADOS_2025 = {
  gobiernoCorporativo: gobiernoCorporativo2025,
  memoriaSostenibilidad: sostenibilidad2025,
};
